/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { Popover, Progress, Typography } from "antd";
import PopOverHours from "./PopOverHours";

function HourCard(props: any) {
  const { column, isWeekend } = props;
  const [openHours, setOpenHours] = useState(false);
  // const isToday = selectedDate
  //   ? new Date(selectedDate).toDateString() === new Date().toDateString()
  //   : false;

  const handleOpenHoursChange = (newOpen: boolean) => {
    setOpenHours(newOpen);
  };

  let actualHours = 0;
  let totalHours = 0;
  let mergeCrewArray: any[] = [];

  if (props.totalHours || props.actualHours) {
    totalHours = props.totalHours || 0;
    actualHours = props.actualHours || 0;
  } else {
    if (column?.crewAttendances?.length > 0) {
      totalHours = column?.crewAttendances?.length * 8;
      actualHours = column?.crewAttendances?.reduce(
        (sum: number, crew: any) => {
          return sum + (crew?.hoursWorked || 0);
        },
        0
      );
    } else {
      mergeCrewArray = [
        ...(column?.crewLeader
          ? [{ ...column.crewLeader, type: "leader" }]
          : []),
        ...(column?.crewMembers ?? []),
      ];
      actualHours = 0;
      totalHours = mergeCrewArray.length * 8;
    }
  }

  // console.log("column in hour card---", column);

  // const totalVisitsDuration =
  //   column?.visits?.reduce((sum: number, visit: any) => {
  //     return sum + visit?.duration;
  //   }, 0) || 0;
  return (
    <div
      className="column_info_item"
      style={{
        cursor: isWeekend ? "default" : "pointer",
        height: isWeekend ? "auto" : "50px",
      }}
    >
      {isWeekend ? (
        <Typography.Text
          type="secondary"
          style={{
            fontSize: "12px",
            color: "#151718",
            display: "block",
            textAlign: "left",
            fontWeight: 600,
          }}
        >
          N/A
        </Typography.Text>
      ) : (
        <Popover
          trigger="click"
          arrow={false}
          placement="bottomLeft"
          open={openHours}
          onOpenChange={handleOpenHoursChange}
          content={
            <PopOverHours actualHours={actualHours} totalHours={totalHours} />
          }
        >
          <span
            style={{
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            Hours
            {/* {isToday && index === 0 && (
              <img src="/images/potential-deals/octagon-warning.svg" alt="" />
            )} */}
          </span>

          <div style={{ whiteSpace: "nowrap", fontWeight: "600" }}>
            {Number(actualHours) % 1 !== 0
              ? Number(actualHours).toFixed(2)
              : Number(actualHours)}{" "}
            / {totalHours || "0"}
            <Progress
              strokeColor={totalHours < actualHours ? "#D33D3D" : "#00A07D"}
              percent={(actualHours / totalHours) * 100}
              size={["37px", 6]}
              style={{
                marginLeft: "4px",
                display: "inline-flex",
                width: "32px",
              }}
            />
          </div>

          {/* <div
            style={{
              whiteSpace: "nowrap",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Typography.Title
              level={5}
              style={{ margin: "0", fontSize: "1em" }}
            >
              {actualHours ?? 0}/{{ totalHours }}
            </Typography.Title>
            <Progress
              percent={((actualHours ?? 0) / totalHours) * 100}
              showInfo={false}
              strokeColor="#00A07D"
              size="small"
              style={{ width: "40px", marginTop: "0" }}
            />
          </div> */}

          {/* {column ? (
            <div style={{ whiteSpace: "nowrap", fontWeight: "600" }}>
              {Number(actualHours) % 1 !== 0
                ? Number(actualHours).toFixed(2)
                : Number(actualHours)}{" "}
              / {totalHours || "0"}
              <Progress
                strokeColor={totalHours < actualHours ? "#D33D3D" : "#00A07D"}
                percent={(actualHours / totalHours) * 100}
                size={["37px", 6]}
                style={{
                  marginLeft: "4px",
                  display: "inline-flex",
                  width: "32px",
                }}
              />
            </div>
          ) : !isWeekend ? (
            hoursData ? (
              <>
                <div
                  style={{
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Typography.Title
                    level={5}
                    style={{ margin: "0", fontSize: "1em" }}
                  >
                    {actualHours ?? 0}/{{ totalHours }}
                  </Typography.Title>
                  <Progress
                    percent={((actualHours ?? 0) / totalHours) * 100}
                    showInfo={false}
                    strokeColor="#00A07D"
                    size="small"
                    style={{ width: "40px", marginTop: "0" }}
                  />
                </div>
              </>
            ) : (
              <Typography.Text
                type="secondary"
                style={{
                  fontSize: "12px",
                  color: "#151718",
                  display: "block",
                  textAlign: "left",
                  fontWeight: 600,
                }}
              >
                N/A
              </Typography.Text>
            )
          ) : (
            <Typography.Text
              type="secondary"
              style={{
                fontSize: "12px",
                color: "#151718",
                display: "block",
                textAlign: "left",
                fontWeight: 600,
              }}
            >
              0/0
            </Typography.Text>
          )} */}
        </Popover>
      )}
    </div>
  );
}

export default HourCard;
